<template>
    <div>
        <!-- Begin Page Content -->
        <div class="medical-records">
            <div class="row">
                <div class="col-12 mb-4">
                    <div class="card border-0">
                        <div class="card-body bg-white border-radius-5">
                            <div class="card-body">
                                <div class="row no-gutters w-100 searches justify-content-center align-items-center text-center mb-4">
                                    <div class="col-md-3 Records pr-3">
                                        <a href="#" class="d-flex align-items-center">
                                            <div><i class="icon icon-historical-records"></i> <span class="d-block">Historical Records</span></div>
                                        </a>
                                    </div>
                                    <div class="col-md-3 Records pr-3">
                                        <a href="#" class="d-flex align-items-center">
                                            <div><i class="icon icon-historical-trends"></i> <span class="d-block">Historical Trends</span></div>
                                        </a>
                                    </div>
                                    <div class="col-md-3 Records pr-3">
                                        <a href="#" class="d-flex align-items-center">
                                            <div><i class="icon icon-export-report"></i> <span class="d-block">Export Report form doctor</span></div>
                                        </a>
                                    </div>
                                    <div class="col-md-3 Records">
                                        <router-link to="/upload-reports" class="d-flex align-items-center">
                                            <div><i class="icon icon-upload-reports"></i> <span class="d-block">Upload Reports</span></div>
                                        </router-link>
                                    </div>
                                </div>
                                <div class="row no-gutters w-100 searches justify-content-center align-items-center text-center mb-4">
                                    <div class="col-md-3 Records pr-3">
                                        <a href="#" class="d-flex align-items-center">
                                            <div><i class="icon icon-suggested-test"></i> <span class="d-block">Suggested Test</span></div>
                                        </a>
                                    </div>
                                    <div class="col-md-3 Records pr-3">
                                        <a href="#" class="d-flex align-items-center">
                                            <div><i class="icon icon-medical-records"></i> <span class="d-block">View Medical Records</span></div>
                                        </a>
                                    </div>
                                    <div class="col-md-3 Records pr-3">
                                        <a href="#" class="d-flex align-items-center">
                                            <div><i class="icon icon-order-list"></i> <span class="d-block">Order List</span></div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- End of Page Wrapper -->
    </div>
</template>
<script>
    export default {
        name: "medical-records",
        data() {
            return {};
        },
        created(){
           this.pageName('Medical Records')
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/website/consultant/medical-records.vue